import React from "react";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { MenuItem } from "@material-ui/core";
import useStyles from "./styles";

export default function MaterialCustomDropDown({
  onDropDownChange,
  dropDownData,
}) {
  const classes = useStyles();
  const [selectedValue, setselectedValue] = React.useState(
    dropDownData[0].value,
  );

  const handleChange = (event) => {
    onDropDownChange(event.target.value);
    setselectedValue(event.target.value);
  };
  const options = dropDownData.map((i, index) => (
    <MenuItem key={index} className={"search-paramter-label"} value={i.value}>
      {i.label}
    </MenuItem>
  ));
  const theme = createMuiTheme({
    props: {
      MuiSelect: {
        MenuProps: {
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
        },
      },
    },
  });

  return (
    <div>
      <ThemeProvider theme={theme}>
        <FormControl
          className={classes.formControl}
          style={{ minWidth: "auto" }}
        >
          <Select
            className={classes.selectBox}
            value={selectedValue}
            onChange={handleChange}
            id="simple-dropdown-label-select"
          >
            {options}
          </Select>
        </FormControl>
      </ThemeProvider>
    </div>
  );
}
